import styled from 'styled-components';

import { StyledButton } from '~/components/Button/styles';
import {
  Content as InputPasswordContent,
  Box,
} from '~/components/Formik/inputPassword/styles';
import grid from '~/styles/grid';

export const Container = styled.div`
  ${InputPasswordContent} {
    margin-bottom: ${grid.md};
  }

  ${Box} {
    margin: 0 0 5px 0 !important;
  }

  label {
    font-weight: bold !important;
  }

  ${StyledButton} {
    width: 100%;
  }
`;

export const InputContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${grid.md};
`;

export const PasswordAcceptBox = styled.div`
  width: 100%;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  margin-bottom: ${grid.lg};
`;

export const PasswordAcceptOption = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #e6e6e6;
  padding: ${grid.sm};
`;

export const PasswordAcceptText = styled.span`
  font-weight: bold;
  color: #6c6c6c;
  margin-left: ${grid.md};
`;

export const PasswordMessage = styled.p`
  margin: ${grid.md} 0;
  text-align: center;
`;
